<template>
<el-row>

  <el-row>

  <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
    <el-tab-pane label="渠道收入结算" name="first">
      <el-alert
        title="温馨提示：每年3月15日、6月15日、9月15日、12月15日出上季度账单，请在账单出来后进行核算和查看账单明细，确保账单准确无误！车小花在收到发票验证后3个工作日内向贵方渠道指定账户支付相应金额。"
        type="warning"
        show-icon
        :closable="false">
      </el-alert>

    <el-row style="margin-top:20px;">
    <el-dialog title="账单明细" :visible.sync="dialogTableVisible">
      <el-table :data="clueDetailData" v-loading.body="detailLoading">
        <el-table-column property="date" label="日期" width="150"></el-table-column>
        <el-table-column property="clueCount" label="线索量" width="200"></el-table-column>
        <el-table-column property="cluePrice" label="线索单价"></el-table-column>
        <el-table-column property="clueTotalPrice" label="线索收入"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="imgVisible" size="tiny">
      <img width="100%" :src="voucherImageUrl" alt>
    </el-dialog>
      <el-table
        :data="setttlementData"
        v-loading.body="loading"
        border
        style="width: 100%">
        <el-table-column
          label="账单季度"
          width="180">
          <template scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.statementQuarter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="渠道名称"
          width="180">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.channelName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="收款账户"
          width="180">
          <template scope="scope">

          <el-popover trigger="hover" placement="top">
            <p> {{ scope.row.name }}</p>
            <p> {{ scope.row.bankAccount }}</p>
            <p> {{ scope.row.bankName }}</p>
            <p> {{ scope.row.bankBranchName }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag>{{ scope.row.name }}</el-tag>
            </div>
          </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="账单金额"
          width="100">
          <template scope="scope">

            <span style="margin-left: 10px">{{ scope.row.totalSettlementOfQuarter }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="结算状态"
          width="100">
          <template scope="scope">

            <span style="margin-left: 10px" v-if="scope.row.state==1">未结算</span>
            <span style="margin-left: 10px" v-else-if="scope.row.state==2">已结算</span>
          </template>
        </el-table-column>
        <el-table-column
          label="结算凭证"
          width="220">
          <template scope="scope"  >
            <span v-for="item in scope.row.voucherArr"   style="">
              <img @click="handlePictureCardPreview(item)" style=" width:90px;height:90px;display: inline;" :src="item" alt>
            </span>

          </template>
        </el-table-column>
        <el-table-column
          label="结算时间"
          width="auto">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.statementTime|dateTimeFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" >
          <template scope="scope">
            <el-button v-show="scope.row.state==1"
              size="small"
              @click="$refs['uploadVoucherDialog'].show(scope.row)">账单结算
            </el-button>

            <el-button
                size="small"
               @click="showDetail(scope.row.id)">查看账单明细
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination class="row basic-margin"
        @size-change="settHandleSizeChange"
        @current-change="settHandleCurrentChange"
        :current-page="settCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="settPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="settTotalCount">
      </el-pagination>

      <upload-voucher-dialog ref="uploadVoucherDialog"  v-on:handleSuccess="handleSuccess()"></upload-voucher-dialog>
    </el-row>
    </el-tab-pane>

    <el-tab-pane label="线索充值管理" name="second" >
    <el-row>
      <el-table
        :data="rechargeData"
        v-loading.body="rechargeloading"
        border
        style="width: 100%">
        <el-table-column
          label="ID"
          width="auto">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="商家名称"
          width="auto">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.busineeName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值金额"
          width="auto">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.rechargeMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="对应宝袋流水号"
          width="auto">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值时间"
          width="auto">
          <template scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.createTime|dateTimeFormat }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="rechargeHandleSizeChange"
        @current-change="rechargeHandleCurrentChange"
        :current-page="rechargeCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="rechargePageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="rechargeTotalCount">
      </el-pagination>
    </el-row>
    </el-tab-pane>
  </el-tabs>
  </el-row>
</el-row>

</template>

<script>
import BasicPager from '../../mixins/BasicPager'
import SettlementModel from '../../framework/models/settlementModel'
import UploadVoucherDialog from './children/uploadVoucherDialog'

export default {
  name: 'expense-settlement',
  extends: BasicPager,
  data: function () {
    return {
      settlementTime: null,
      settCurrentPage: 1, // 起始
      settPageSize: 10, // 步长
      settTotalCount: 0, // 总条数
      rechargeCurrentPage: 1, // 起始
      rechargePageSize: 10, // 步长
      rechargeTotalCount: 0, // 总条数
      dialogVisible: false,
      activeName2: 'first',
      loading: false,
      detailLoading: false,
      imgVisible: false,
      voucherImageUrl: '',
      clueDetailData: [{
        date: '2016-05-02',
        clueCount: 20,
        cluePrice: 10,
        clueTotalPrice: 200
      }],
      dialogTableVisible: false,
      setttlementData: [{

      }],
      rechargeData: [{

      }]
    }
  },
  watch: {
    currentPage: function () {
      this.loadList()
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    handleSuccess () {
      this.loadList()
    },
    settHandleSizeChange (val) { // 监听页数变化
      this.settPageSize = val
      this.loadList()
    },
    settHandleCurrentChange (val) { // 监听页码变化
      this.settCurrentPage = val
      this.loadList()
    },
    rechargeHandleSizeChange (val) { // 监听页数变化
      this.rechargePageSize = val
      this.loadRechargeList()
    },
    rechargeHandleCurrentChange (val) { // 监听页码变化
      this.rechargeCurrentPage = val
      this.loadRechargeList()
    },
    handleClick (tab, event) {
      if (tab.name == 'first') {
        this.loadList()
      } else if (tab.name == 'second') {
        this.loadRechargeList()
      }
    },

    handlePictureCardPreview (imageUrl) {
      this.voucherImageUrl = imageUrl
      this.imgVisible = true
    },
    showDetail (id) {
      this.dialogTableVisible = true
      let _this = this
      _this.detailLoading = true

      let params = {
        id: id
      }

      let listener = {
        onResponse: function () {
          _this.detailLoading = false
        },
        success: function (dataInfo) {
          _this.clueDetailData = dataInfo.data
        }
      }
      SettlementModel.findSettlementDetail(_this, params, listener)
    },
    loadList: function () {
      let _this = this

      _this.loading = true

      let params = {
        start: _this.settCurrentPage,
        length: _this.settPageSize
      }

      let listener = {
        onResponse: function () {
          _this.loading = false
        },
        success: function (dataInfo) {
          _this.setttlementData = dataInfo.data
          _this.settTotalCount = dataInfo.recordsTotal
        }
      }
      SettlementModel.findSettlementRecord(_this, params, listener)
    },
    loadRechargeList: function () {
      let _this = this

      _this.loading = true
      let params = {
        start: _this.rechargeCurrentPage,
        length: _this.rechargePageSize
      }

      let listener = {
        onResponse: function () {
          _this.loading = false
        },
        success: function (dataInfo) {
          _this.rechargeData = dataInfo.data
          _this.rechargeTotalCount = dataInfo.recordsTotal
        }
      }
      SettlementModel.findBussinessRecharge(_this, params, listener)
    },
    sendMsg: function () {
      let _this = this
      _this.loading = true
      let params = {}
      let listener = {
        onResponse: function () {
          _this.loading = false
        },
        success: function (dataInfo) {
        }
      }
      SettlementModel.sendMsg(_this, params, listener)
    }
  },
  components: {
    UploadVoucherDialog
  }
}
</script>
